import { Stack, Theme } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import _ from 'lodash';
import React from 'react';
import { Col, Container, Form, Row } from 'react-bootstrap';
import colors from '../../../../constants/colors';

import { TokenAnnotator, TextAnnotator } from 'react-text-annotate'
import { SmsAnnotationT } from '../../../../types/SmsAnnotationT';


const TAG_COLORS = {
    DEFAULT: "rgb(166, 226, 45)",
}


const useStyles = makeStyles((theme: Theme) => createStyles({
    highlighted: {
        cursor: "pointer",
        padding: theme.spacing(2),
        "&:hover": {
            backgroundColor: "#ccc",
        },
        "&.active": {
            backgroundColor: "#ccc",
        },
    }
}))




export type IAnnotationSmsProps = {
    item: SmsAnnotationT
    index: number
    body?: string
    // updateAnnotation?(): void
    updateLineItem(index: number, item: SmsAnnotationT): void
    removeLineItem(index: number): void
    displayMode?: "edit" | "view"
}

const AnnotationSms: React.FC<IAnnotationSmsProps> = (props) => {
    const [wordsActive, setWordsActive] = React.useState([]);
    const [state, setState] = React.useState({
        value: [],
        tag: "DEFAULT"
    });
    const [value, setValue] = React.useState([]);
    const classes = useStyles()

    React.useEffect(() => {
        if (_.isArray(props?.item?.words)) {
            setValue(props?.item?.words)
        }
        // console.log("AnnotationSms",props.item)
    }, []);
    const body = props?.body
    // console.log("body", body)

    // console.log("bodyArray", bodyArray)
    const onChangeValue = (key: string, value: any) => {
        let cloneItem = _.cloneDeep(props?.item)
        cloneItem[key] = value
        props.updateLineItem(props.index, cloneItem)
    }

    return (
        <Container className='mt-4' style={{ textAlign: 'left', position: "relative" }}>
            <div className='mt-2'>
                <TokenAnnotator
                    style={{
                        // border: "1px solid #ccc",
                        // padding: 5,
                        // paddingTop: 10,
                        // paddingBottom: 10,

                    }}
                    tokens={body.split(' ')}
                    value={value}
                    onChange={(value) => {
                        if (props.displayMode == "edit") {
                            setValue(value)

                            onChangeValue("words", value)
                            // console.log("e", value)
                        }
                    }}
                    getSpan={span => ({
                        ...span,
                        tag: state.tag,
                        color: TAG_COLORS[state.tag],
                    })}
                    // onChange={this.handleChange}
                    renderMark={props => (
                        <mark style={{ backgroundColor: props.color }} key={props.key} onClick={() => props.onClick({ start: props.start, end: props.end })}>
                            {props.content}
                        </mark>
                    )} />

            </div>
            <Row className='mt-2'>
                <Col>
                    {props?.displayMode == "edit" ? <Form.Group>
                        <Form.Label>Summary</Form.Label>
                        <Form.Control as="textarea"
                            value={`${props?.item?.notes}`}
                            rows={3} onChange={(event: any) => {
                                let value = event.target.value
                                onChangeValue("notes", value)
                            }} />
                    </Form.Group> : <Stack flexDirection={"column"}>
                        <Form.Label>Summary</Form.Label>
                        <Stack className='' p={2}  style={{ border: "1px solid #ccc" }}>
                            <span>{props?.item?.notes}</span>
                        </Stack>
                    </Stack>}
                </Col>
            </Row>
            {props?.displayMode == "edit" && <div style={{
                position: "absolute",
                top: -2,
                right: -20,
                // border: "1px solid #cc0000",
                borderRadius: 20,
                height: 30,
                width: 30,
                display: "flex",
                cursor: "pointer"
            }}
                onClick={() => props.removeLineItem(props.index)} >
                <div className='w-100 d-flex justify-content-center align-items-center'>
                    <i className='fa fa-close' style={{ color: colors.red }} />
                </div>
            </div>}
        </Container>
    )
}

export default AnnotationSms